import { Controller } from "@hotwired/stimulus"
import { place } from "../lib/anchor"

// The "?" beside a term, and the panel it opens.
//
// The behaviour is the platform's. The button carries popovertarget and the
// panel carries the popover attribute, so opening, closing on Esc, closing on
// a click anywhere else, keeping one open at a time and handing focus back to
// the button are all the browser's — none of it is written here, and none of
// it can be written wrong. See UiHelper#help_popover and HelpPopover.vue for
// the markup this expects.
//
// What the platform does not do is put the panel next to the button: a
// popover with no anchor is centred in the window. So this listens for the
// panel opening and places it, then moves focus into it so a screen reader
// reads the explanation that was asked for rather than sitting on the button
// that asked. The panel is dismissed on scroll and resize instead of being
// dragged along behind its anchor — a few lines of help are not worth
// tracking the page's every movement for.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this.toggled = this.toggled.bind(this)
    this.dismiss = this.dismiss.bind(this)
    this.panelTarget.addEventListener("toggle", this.toggled)
  }

  disconnect() {
    this.panelTarget.removeEventListener("toggle", this.toggled)
    this.unwatch()
  }

  toggled(event) {
    if (event.newState !== "open") return this.unwatch()

    place(this.panelTarget, this.triggerTarget, { side: "bottom", align: "start" })
    this.panelTarget.focus()
    window.addEventListener("scroll", this.dismiss, true)
    window.addEventListener("resize", this.dismiss)
  }

  unwatch() {
    window.removeEventListener("scroll", this.dismiss, true)
    window.removeEventListener("resize", this.dismiss)
  }

  dismiss(event) {
    // Scrolling the explanation itself is reading it, not leaving it.
    if (event.type === "scroll" && this.panelTarget.contains(event.target)) return

    this.panelTarget.hidePopover()
  }
}
